import axios from "axios";
import { getErrorMessage } from "../utils/errorHandling";

export const searchDocuments = async (query: string, token: string) => {
    const baseUrl = window.location.origin + "/document-store";
    const url = `${baseUrl}/get_filenames_by_query`;

    try {
        const response = await axios.get(url, {
            params: { query },
            headers: {
                "Authorization": `Bearer ${token}`,
                "conversation-id": "1",
            }
        });
        return response.data;
    } catch (error) {
        const message = getErrorMessage(error);
        console.error("DocFinder API Error:", message, error);
        throw new Error(message);
    }
};
    